<template>
  <div>
    <v-row dense>
      <v-col cols="12" md="4">
        <v-row class="image-width" align="center" justify="center">
          <v-img
            :src="getImageUrl(settings.logo)"
            v-if="settings.logo"
            contain
            class="image-preview"
          >
            <v-row justify="center" align="center" class="fill-height">
              <primary-button color="error" @click="$emit('select-image', 'logo')">
                {{ $t("logo") }}
              </primary-button>
              <remove-button
                style="position: absolute; top: 85px"
                @click="$emit('remove-image', 'logo')"
              />
            </v-row>
          </v-img>
          <v-btn
            v-else
            class="ma-2"
            outlined
            color="primary"
            small
            @click="$emit('select-image', 'logo')"
          >
            {{ $t("logo") }}
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row class="image-width" align="center" justify="center">
          <v-img
            :src="getImageUrl(settings.header)"
            v-if="settings.header"
            contain
            class="image-preview"
          >
            <v-row justify="center" align="center" class="fill-height">
              <primary-button color="error" @click="$emit('select-image', 'header')">
                {{ $t("header") }}
              </primary-button>
              <remove-button
                style="position: absolute; top: 85px"
                @click="$emit('remove-image', 'header')"
              />
            </v-row>
          </v-img>
          <v-btn
            v-else
            class="ma-2"
            outlined
            color="primary"
            small
            @click="$emit('select-image', 'header')"
          >
            {{ $t("header") }}
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row align="center" class="image-width" justify="center">
          <v-img
            :src="getImageUrl(settings.restoran_image)"
            v-if="settings.restoran_image"
            contain
            class="image-preview"
          >
            <v-row justify="center" align="center" class="fill-height">
              <primary-button
                color="error"
                @click="$emit('select-image', 'restoran_image')"
              >
                {{ $t("restaurant") }}
              </primary-button>
              <remove-button
                style="position: absolute; top: 85px"
                @click="$emit('remove-image', 'restoran_image')"
              />
            </v-row>
          </v-img>
          <v-btn
            v-else
            class="ma-2"
            outlined
            color="primary"
            small
            @click="$emit('select-image', 'restoran_image')"
          >
            {{ $t("restaurant") }}
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import conf from "@/config";

export default {
  name: "WebDesignSection",
  props: {
    settings: {
      type: Object,
      required: true,
    },
    restaurantId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      conf: conf,
    };
  },
  methods: {
    getImageUrl(imageName) {
      if (!imageName) return "";
      return `${this.conf.apiUrlBase}/gallery/${this.restaurantId}/medium/${imageName}`;
    },
  },
};
</script>

<style scoped>
.image-width {
  width: 100%;
  max-width: 280px;
  height: 140px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow: hidden;
}

.image-preview {
  max-width: 100%;
  max-height: 100%;
}
</style>
